// ─────────────────────────────────────────────────────────────────────────────
// Import-validation engine — reference values (spec §10 step-3 / PRD §10, Figure-3).
//
// The provider uploads IMPORT_FOR_PARTNER_VALIDATION_DDMMYYYY (.xlsx or .csv,
// OQ-3). The engine here is PURE and works on already-parsed, normalized rows —
// file parsing is a thin adapter at the API/frontend layer (like the log's
// injected Hasher/Signer). Values are matched EXACTLY (no case-folding); the
// adapter is responsible for supplying clean canonical values, so a data-quality
// issue surfaces rather than being silently absorbed.
// ─────────────────────────────────────────────────────────────────────────────
/** The provider's per-row `Eligible for invoicing` decision (spec §6). Matched exactly (uppercase). */
export const ELIGIBILITY_DECISIONS = ['OK', 'REMOVE', 'ADD'];
/** Figure-3: an import row whose `MDU_ID` is not found in the eligibles is ADDED, flagged not-in-DMP. */
export const NOT_IN_DMP_FLAG = 'RED';
//# sourceMappingURL=data.js.map